import DOMPurify from 'dompurify'
import { Link } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

import { Document } from '../../types/document.types'

const DocumentErrorDownloading = ({ documentData, handleDownloadUploadedDocument }: { documentData: Partial<Document>; handleDownloadUploadedDocument: () => void }) => {
  const { t } = useTranslation(['document-details-management'])
  const errorDescriptionHtml = documentData.errorDescription ? DOMPurify.sanitize(documentData.errorDescription) : ''

  return (
    <div className="document-details-findings-container">
      <div className="document-details-findings-text">
        <Link
          to="#"
          component={RouterLink}
          onClick={(event) => {
            event.preventDefault()
            handleDownloadUploadedDocument()
          }}
          className="document-details-findings-link"
        >
          {t('documentErrorDownloading.clickHere')}
        </Link>{' '}
        {t('documentErrorDownloading.mainMessage')}
      </div>
      {documentData.errorDescription && (
        <div className="document-details-findings-text">
          <strong>{t('documentErrorDownloading.errorDescription')}</strong>
          <br />
          <br />
          <div dangerouslySetInnerHTML={{ __html: errorDescriptionHtml }} />
        </div>
      )}
      <div className="document-details-findings-text">
        <strong>{t('documentErrorDownloading.uploadedBy')}</strong> {`${documentData.uploadedByFullName}`}
      </div>
    </div>
  )
}

export default DocumentErrorDownloading
